import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import AWS from 'aws-sdk'

library.add(faPlusCircle)

const bucketName = 'portal-profile-image'
const bucketRegion = 'sa-east-1'
const IdentityPoolId = 'sa-east-1:bc7f9ff6-d461-4870-b480-29756e9502e9'
let s3 = null as any

@Component({
	components: {
		Loader,
	},
})
export default class Invite extends Vue {
	form = {
		password: '',
		repeatPassword: '',
		file: [] as Array<File>,
		aceite: false,
		phone_number: '',
	}

	read = {
		name: '',
		email: '',
	}

	submitLoading = false
	errorMsg = ''
	invalid = false
	loading = false

	awsSetup() {
		AWS.config.update({
			region: bucketRegion,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: IdentityPoolId,
			}),
		})

		s3 = new AWS.S3({
			apiVersion: '2006-03-01',
			params: { Bucket: bucketName },
		})
	}

	uploadImage(callback) {
		const emptyImageUrl = ''
		if (!(this.form.file instanceof File)) {
			// imagem é opcional, se nao houver prosseguir com finalizacao de cadastro
			callback(emptyImageUrl) // callback('') causa um erro de ts: no-callback-literal
			return
		}

		// timestamp-randomString_originalFilename
		const fileName =
			Date.now() +
			'-' +
			Math.round(Math.random() * 1e5) +
			'_' +
			this.form.file.name

		s3.upload(
			{
				Bucket: bucketName,
				Key: fileName,
				Body: this.form.file,
				ContentType: this.form.file.type,
			},
			(err, data) => {
				/**
				 * data: {
				 *   Bucket, (bucket name)
				 *   ETag, (random string)
				 *   Key, (filename)
				 *   Location, (full url)
				 *   key, (filename)
				 * }
				 */
				if (err) {
					this.$bvToast.toast(
						'Não foi possível fazer upload da sua imagem. Prosseguindo com a finalização do cadastro',
						{
							title: 'Erro',
							variant: 'danger',
							solid: true,
							toaster: 'b-toaster-top-center',
						},
					)
					callback(emptyImageUrl)
				} else {
					callback(data.Location)
				}
			},
		)
	}

	async submit() {
		if (!this.form.aceite) {
			this.errorMsg =
				'Para prosseguir você precisa concordar com nossos termos de uso'
			return
		}

		if (this.form.password === '') {
			this.errorMsg = 'Por favor, preencha uma senha'
			return
		}

		if (this.form.password.length < 5 || this.form.password.length > 16) {
			return
		}

		if (this.form.password !== this.form.repeatPassword) {
			this.errorMsg = 'As senhas não coincidem'
			return
		}

		this.submitLoading = true
		this.uploadImage(async (imageUrl) => {
			const formData = {
				password: this.form.password,
				aceite: String(this.form.aceite),
				imageUrl,
				phone_number: this.form.phone_number,
			}

			const res = await api.post(
				'/api/invite/' + this.$route.params.inviteCode,
				formData,
			)
			this.submitLoading = false
			if (res.ok) {
				this.$bvToast.toast('Redirecionando para login...', {
					title: 'Sucesso!',
					variant: 'success',
					solid: true,
					toaster: 'b-toaster-top-center',
				})

				setTimeout(() => {
					this.$router.push('/login')
				}, 2000)
			} else {
				if (res.cod === 'INVITE_NOT_FOUND') {
					this.errorMsg = 'Convite não encontrado'
				} else if (res.cod === 'UNABLE_TO_SAVE_AGREEMENT') {
					this.errorMsg = 'Erro ao salvar aceite'
				} else {
					this.errorMsg = 'Erro desconhecido: ' + res.msg
				}
			}
		})
	}

	get passwordHasError() {
		return this.form.password.length < 5 || this.form.password.length > 16
	}

	async mounted() {
		this.loading = true
		const res = await api.get(
			'/api/invite/' + this.$route.params.inviteCode,
		)
		this.loading = false

		if (res.ok) {
			Object.assign(this.read, res.data)
			this.awsSetup()
		} else this.invalid = true
	}
}
